// DS: i3.38
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const CreateVariations: React.FC<Props> = props => {
  return (
    <IconWrap {...props} disableDefaultColors>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M15 3a1 1 0 100 2h2.542l-6.368 6H4a1 1 0 100 2h7.968L19 6.374V9a1 1 0 102 0V3.8a.8.8 0 00-.8-.8H15zm.113 11.442a1 1 0 10-1.226 1.58L17.724 19H15a1 1 0 100 2h5.2a.8.8 0 00.8-.8V15a1 1 0 10-2 0v2.458l-3.887-3.016z"
        />
      </svg>
    </IconWrap>
  );
};

CreateVariations.displayName = 'CreateVariations';

export default CreateVariations;
